/**
 * Cart Modal — Pompeii
 * "AÑADIDO A LA CESTA" modal for desktop.
 * Shows cart items after add-to-cart or when clicking Bolsa link.
 * Falls back to /cart on mobile.
 */
(function () {
  var overlay = document.getElementById('CartModalOverlay');
  var modal = document.getElementById('CartModal');
  if (!overlay || !modal) return;

  var itemsContainer = modal.querySelector('.cart-modal__items');
  var footerEl = modal.querySelector('.cart-modal__footer');
  var viewCartBtn = modal.querySelector('.cart-modal__btn--outline');

  /* ── Helpers ── */
  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' EUR';
  }

  function isMobile() {
    return window.innerWidth < 750;
  }

  /* ── Open / Close ── */
  function openModal() {
    fetchCart().then(render);
    overlay.classList.add('is-open');
    modal.classList.add('is-open');
    document.body.style.overflow = 'hidden';
  }

  function closeModal() {
    overlay.classList.remove('is-open');
    modal.classList.remove('is-open');
    document.body.style.overflow = '';
  }

  /* Close button */
  modal.querySelector('.cart-modal__close').addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);

  /* ESC key */
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal.classList.contains('is-open')) closeModal();
  });

  /* ── Intercept cart link clicks on desktop ── */
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="/cart"]');
    if (!link) return;
    if (link.href.includes('/checkout')) return;
    if (link.closest('.cart-modal')) return;
    if (link.matches('[data-cart-remove]') || link.closest('[data-cart-remove]')) return;
    if (link.closest('.cart-page__remove')) return;
    e.preventDefault();
    openModal();
  });

  /* ── Fetch cart ── */
  function fetchCart() {
    return fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); });
  }

  /* ── Render cart ── */
  function render(cart) {
    if (!cart.items || cart.items.length === 0) {
      itemsContainer.innerHTML = '<div class="cart-modal__empty">Tu cesta está vacía</div>';
      footerEl.style.display = 'none';
      updateHeaderCount(0);
      return;
    }

    footerEl.style.display = '';
    var count = cart.item_count;

    var html = '';
    cart.items.forEach(function (item) {
      html += '<div class="cart-modal__item" data-line-key="' + item.key + '">';
      html += '  <div class="cart-modal__item-image">';
      if (item.image) {
        html += '    <img src="' + getSizedImageUrl(item.image, '300x') + '" alt="' + escapeHtml(item.product_title) + '" loading="lazy">';
      }
      html += '  </div>';
      html += '  <div class="cart-modal__item-info">';
      html += '    <span class="cart-modal__item-title">' + escapeHtml(item.product_title) + '</span>';
      if (item.variant_title) {
        html += '    <p class="cart-modal__item-variant">TALLA: ' + escapeHtml(item.variant_title) + '</p>';
      }
      html += '    <p class="cart-modal__item-price">' + formatMoney(item.final_line_price) + '</p>';
      html += '    <div class="cart-modal__item-actions">';
      html += '      <div class="cart-modal__item-qty">';
      html += '        <button type="button" class="cart-modal__qty-btn" data-action="minus" data-key="' + item.key + '">&minus;</button>';
      html += '        <span class="cart-modal__qty-value">' + item.quantity + '</span>';
      html += '        <button type="button" class="cart-modal__qty-btn" data-action="plus" data-key="' + item.key + '">+</button>';
      html += '      </div>';
      html += '      <button type="button" class="cart-modal__item-remove" data-key="' + item.key + '">Eliminar</button>';
      html += '    </div>';
      html += '  </div>';
      html += '</div>';
    });

    itemsContainer.innerHTML = html;

    /* Update "VER CESTA" button text with count */
    if (viewCartBtn) {
      const span = viewCartBtn.querySelector('span') || viewCartBtn;
      span.textContent = 'VER CESTA (' + (count < 10 ? '0' : '') + count + ')';
    }

    updateHeaderCount(count);
  }

  /* ── Header cart count update ── */
  function updateHeaderCount(count) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = count > 0 ? '(' + count + ')' : '';
    });
  }

  /* ── Image sizing helper ── */
  function getSizedImageUrl(url, size) {
    if (!url) return '';
    var match = url.match(/(.+)\.(jpg|jpeg|png|gif|webp)/i);
    if (match) return match[1] + '_' + size + '.' + match[2];
    return url;
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.appendChild(document.createTextNode(str));
    return div.innerHTML;
  }

  /* ── Update cart quantity ── */
  function updateQuantity(key, qty) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(render);
  }

  /* Delegated events for qty buttons and remove */
  itemsContainer.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-action]');
    if (btn) {
      var key = btn.dataset.key;
      var current = parseInt(btn.parentElement.querySelector('.cart-modal__qty-value').textContent, 10);
      if (btn.dataset.action === 'minus') {
        updateQuantity(key, Math.max(0, current - 1));
      } else {
        updateQuantity(key, current + 1);
      }
      return;
    }
    var removeBtn = e.target.closest('.cart-modal__item-remove');
    if (removeBtn) {
      updateQuantity(removeBtn.dataset.key, 0);
    }
  });

  /* ── Listen for custom cart events ── */
  document.addEventListener('cart:updated', function () {
    if (modal.classList.contains('is-open')) {
      fetchCart().then(render);
    }
  });

  document.addEventListener('cart:open', function () {
    openModal();
  });
})();
